import axios from "axios";
import { printDebugLog, REPORT_BASE_URL, SUCCESS } from "../../constants/Constants";

export const baseListReports = async ({
    authUser, activeShopHash,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        const catgUrl = `${REPORT_BASE_URL}list-shop-reports?token=${authUser.apiToken}&shopHash=${activeShopHash.id}`;
        const response = await axios.get(catgUrl);
        printDebugLog("fetchListReports", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad);
        } else {
            onResponseCallback(null);
        }
    } catch (error) {
        console.error(`fetchListReports`, error);
        onResponseCallback(null);
    }
};